module.exports = __webpack_public_path__ + "img/41.b5d7d221.jpeg";